import { type FC, type ReactNode, useEffect } from 'react';
import { useAvailableCoverages } from 'state/selectors/coverageSelectors';
import { useAppStore } from 'state/store';

const PurchaseViewWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const availableCoverages = useAvailableCoverages();
  const setSelectedCoverages = useAppStore(
    (state) => state.setSelectedCoverages
  );

  /*
  Effect hook to update selected coverages according to available coverages when user arrives to purchase page
  At this point, selected coverages should only contain coverages that are available for the user
  */
  useEffect(() => {
    const availableCoverageProducts = availableCoverages?.map(
      (c) => c.coverageProduct
    );

    setSelectedCoverages((prevSelectedCoverages) =>
      prevSelectedCoverages.filter((coverageProduct) =>
        availableCoverageProducts?.includes(coverageProduct)
      )
    );
  }, [availableCoverages, setSelectedCoverages]);

  return <>{children}</>;
};

export default PurchaseViewWrapper;
